import { Sites } from '@ps/platform-message-framework/common/Sites';
import { RawInput, Translation } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { Country as CountryEnum } from '@swf/core/enums';
import { select } from '@swf/core/store';
import type { FieldNameProp } from '@swf/core/types/Props';
import { getCountries } from '@swf/core/utils/getCountries';

import CountrySelect, { findCountry } from '../CountrySelect/CountrySelect';
import RMFDropDown from '../RMF/components/RMFDropDown/RMFDropDown';
// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import { label, root } from '../TextInput/TextInput.scss';

import { TXTCLI_Country, TXTWCL_Please_select_CountyX } from './Country.messages.json';

interface Props extends FieldNameProp {
  country: string;
  labelClassName?: string;
  labelContent?: React.ReactNode;
  className?: string;
  isRmfFlow?: boolean;
}

const ukCountries = [
  CountryEnum.GreatBritain,
  CountryEnum.Jersey,
  CountryEnum.Gibraltar,
  CountryEnum.Guernsey
];

const isUKCountry = (country: string | CountryEnum): boolean =>
  ukCountries.includes(country as CountryEnum);

const Country: React.FC<Props> = ({
  country,
  fieldName,
  labelClassName,
  labelContent,
  className,
  isRmfFlow
}) => {
  const site = useSelector(select.cms.getSiteId);

  const countries = getCountries(site, country);

  const countryDropDown = (
    <RMFDropDown
      id={fieldName}
      label={TXTCLI_Country}
      options={countries}
      validators={[required(null)]}
      className={classNames(root, className)}
      placeholder={<Translation {...TXTWCL_Please_select_CountyX} />}
    />
  );

  switch (true) {
    case isRmfFlow && isUKCountry(country):
      return countryDropDown;
    case site === Sites.SPA:
      return (
        <CountrySelect name={fieldName} title={TXTCLI_Country} hideSelect>
          {countryDropDown}
        </CountrySelect>
      );
    default:
      return (
        <RawInput
          id={fieldName}
          label={TXTCLI_Country}
          labelClassName={classNames(label, labelClassName)}
          labelContent={labelContent}
          rawValue={findCountry(country)?.text || ''}
          className={classNames(root, className)}
          disabled
        />
      );
  }
};

export default Country;
